export const QUOTIBLE_LANDING_PAGE_TYPE_ID = 20;
